import { AddressFinder } from "@ideal-postcodes/address-finder";

const AddressLookup = () => {
    const container = document.querySelector(".js-address-finder");
    if (container === null) {
        return;
    }

    AddressFinder.setup({
        apiKey: "ak_i23dkakySEE71uTFZr5iPOCM26mYn",
        inputField: "#address_lookup",
        outputFields: {
            line_1: "#address_1",
            line_2: "#address_2",
            post_town: "#city",
            postcode: "#postcode",
        },
    });
};

export default AddressLookup;
